export default {"src":"/_next/static/media/0x99d8a9c45b2eca8864373a26d1459e3dff1e17f3.652cee79.svg","height":108,"width":108,"blurWidth":0,"blurHeight":0};